// Shared joint (two-insured) projection primitives. The universal
// MonthlyState.waitingPeriod slot is single-insured, so joint runs carry both
// spouses' elimination-period balances in strategyState (`JointWaitingPeriod`)
// and surface the active claimant's onto each row. See
// docs/joint-policy-strategies-plan.md A8.

export type Claimant = 'client' | 'partner';

export interface JointWaitingPeriod {
  client: WaitingPeriodState;
  partner: WaitingPeriodState;
}

// Seed both spouses' EP from the (shared, cloned) policy. Distinct copies so
// they decrement independently.
export function seedJointWaitingPeriod(seed: WaitingPeriodState): JointWaitingPeriod {
  return { client: { ...seed }, partner: { ...seed } };
}
